import { Button, Typography } from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import React from 'react';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export interface LinkButtonProps {
  title?: string;
  disabled?: boolean;
  children?: React.ReactNode;
  fontWeight?: 'inherit' | 'bold' | '';
  padding?: 'inherit' | 'bold' | '';
  fontSize?: 'inherit' | 'bold' | '';
  url: string;
  sx?: SxProps<Theme>;
}

export function LinkButton({
  title,
  disabled,
  url,
  padding,
  fontWeight,
  fontSize,
  children = <AddCircleRoundedIcon />,
  sx = [],
}: LinkButtonProps) {
  return (
    <Button
      disabled={disabled ?? false}
      component={Link}
      to={url}
      sx={{
        ...sx,
        ...{
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
        ...{
          fontWeight: !fontWeight ? 'inherit' : fontWeight,
          padding: !padding ? '' : padding,
          fontSize: !fontSize ? 'inherit' : fontSize,
        },
      }}
    >
      {children}
      {title && (
        <Typography variant='button' ml={1} fontSize={'12px'}>
          {title}
        </Typography>
      )}
    </Button>
  );
}
